import { useSyncExternalStore } from 'react';
import { obtenerSnapshot, suscribir, type EstadoConexion } from './estadoConexion';

export { registrarFalloDeRed, registrarExitoDeRed } from './estadoConexion';
export type { EstadoConexion } from './estadoConexion';

/**
 * Distingue un fallo de RED —la peticion nunca llego o nunca volvio— de un rechazo de
 * NEGOCIO con la conexion intacta (`E_DESGLOSE_NO_CUADRA`, `E_JORNADA_SIN_MONTOS`, ...).
 * Mezclar los dos en el mismo contador arruinaria la unica razon por la que el contador
 * existe: decidir con datos, y no con miedo, si algun dia hay que reabrir la discusion
 * del borrador local.
 *
 * `TypeError` es lo que lanza `fetch` cuando la peticion no sale de la maquina
 * ("Failed to fetch" en Chrome, "Load failed" en Safari). Los `PGRST0xx` son la otra
 * punta del mismo problema: PostgREST contesta, pero contesta que no pudo hablar con la
 * base. Los `PGRST1xx` y `PGRST3xx` son negocio —un JWT vencido, un filtro mal armado— y
 * llegan con la conexion perfecta, asi que NO cuentan.
 */
export function esFalloDeRed(error: unknown): boolean {
  if (error instanceof TypeError) return true;
  if (typeof error === 'object' && error !== null && 'code' in error) {
    return /^PGRST0/.test(String((error as { code: unknown }).code));
  }
  return false;
}

/**
 * SE LLAMA `useEstadoConexion` Y NO `usarEstadoConexion`, que es como lo pedia el plan.
 * Es la adjudicacion 49 aplicada al pie de la letra: esta funcion llama a
 * `useSyncExternalStore`, y el compilador de React reconoce un hook por `^use[A-Z0-9]`.
 * Con el nombre en español se compila como funcion cualquiera y su valor de retorno se
 * memoiza, de modo que el estado de conexion queda congelado en el primero. Una pantalla
 * que no se entera de que se cayo la red es lo contrario de lo que esta tarea construye.
 */
export function useEstadoConexion(): EstadoConexion {
  return useSyncExternalStore(suscribir, obtenerSnapshot, obtenerSnapshot);
}
